// @flow

import React from "react";
import options from "../utils/options";
import type { SchemaTableWidgetProps } from "../types";

export class SelectOptimised extends React.Component<SchemaTableWidgetProps<any>> {
  handleChange = (e: SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(
      this.props.type === "object"
        ? { id: parseInt(e.currentTarget.value) }
        : e.currentTarget.value,
    );
  };

  get value() {
    return this.props.data.id;
  }

  render() {
    const disabled = options.resolveBoolean((this.props.options || {}).disabled, this.props.row);

    if (!this.props.active) {
      return <div className="select__readonly">Read Only!!</div>;
    }
    return (
      <select className="w-100" value={this.value} onChange={this.handleChange} disabled={disabled}>
        {(this.props.oneOf || []).map((opt: { title: string, const: number }) => {
          return (
            <option key={opt.const} value={opt.const}>
              {opt.title}
            </option>
          );
        })}
      </select>
    );
  }
}

export default SelectOptimised;
